// extracted by mini-css-extract-plugin
export default {"statusIndicatorParentDiv":"styles-module__statusIndicatorParentDiv__src-labstep-web-components-EntityStateWorkflow-StatusIndicator-_RFq4g"};